// // Filename: public/additionsDeductionsRepeater.js 
import { uuid } from 'uuidv4';

export let currentAdditionsSum = 0;
export let currentDeductionsSum = 0;

export function repeaterInputItemChange($w, repeater, arr, json, callback, mobile) {

    $w(`#${repeater}`).onItemReady(($item, itemData, index) => {

        json[repeater][index] = arr[index];

        $item(`#${repeater}Type`).onInput(() => {
            let { value } = $item(`#${repeater}Type`);
            let obj = arr.find(item => item._id === itemData._id);
            obj.type = value;

            showRepeaterItemTitle($w, repeater, itemData._id, "type");
            if (!mobile) {

                showPreviewItem($w, repeater, itemData._id, "type", itemData.type)
            }

        });
        $item(`#${repeater}Amount`).onInput(() => {
            let { value } = $item(`#${repeater}Amount`);
            let obj = arr.find(item => item._id === itemData._id);
            obj.amount = value;

            showRepeaterItemTitle($w, repeater, itemData._id, "amount");
            if (!mobile) {
                showPreviewItem($w, repeater, itemData._id, "amount", itemData.amount)
            }

            getadditionDeductionSum(arr, repeater, callback)

        });

        $item(`#${repeater}Delete`).onClick(() => {
            repeaterItemRemove(itemData, arr, json, repeater)
            $w(`#${repeater}`).data = arr;
            if (!mobile) {

                $w(`#P${repeater}`).data = arr;
            }
            getadditionDeductionSum(arr, repeater, callback)

        });
    });
}

function showRepeaterItemTitle($w, repeater, id, type) {
    $w(`#${repeater}`).forEachItem(($item, itemData) => {
        if (id === itemData._id) {
            if (type === "type") $item(`#${repeater}TypeTitle`).show()
            else $item(`#${repeater}AmountTitle`).show()
        }
    });
}

//showing the items in the preview repeaters 
function showPreviewItem($w, repeater, id, type, value) {
    $w(`#P${repeater}`).forEachItem(($item, itemData) => {
        if (id === itemData._id) {
            if (type === "type") {
                $item(`#P${repeater}Type`).text = value
                $item(`#P${repeater}Type`).show()
            } else {
                $item(`#P${repeater}Amount`).text = value
                $item(`#P${repeater}Amount`).show()
            }

        }

    });

}

//add item to the repeaters 
export function addRepeaterItem($w, repeater, arr, type, amount, mobile) {
    let itemToAdd;

    if (arr.length > 7) {
        return
    }

    itemToAdd = {
        _id: uuid(),
        type: "",
        amount: ""

    }

    arr.push(itemToAdd);

    $w(`#${repeater}`).data = arr;
    if (!mobile) {

        $w(`#P${repeater}`).data = arr;
    }

    $w(`#${repeater}`).forEachItem(($item, itemData) => {
        $item(`#${type}`).text = itemData.type;
        $item(`#${amount}`).text = itemData.amount;
    });
    if (!mobile) {
        $w(`#P${repeater}`).forEachItem(($item, itemData) => {
            $item(`#P${type}`).text = itemData.type;
            $item(`#P${amount}`).text = itemData.amount;
        });

    }
    // console.log("arr after adding item", arr);

}

function repeaterItemRemove(itemData, arr, json, repeater) {
    if (arr.length > 1) {
        let index = arr.findIndex(item => item._id === itemData._id);

        arr.splice(index, 1);
        // console.log("removed item is: ", arr[index]);
        json[repeater] = arr;

    }

}

//getting the sum of the additions and deductions 
function getadditionDeductionSum(array, repeater, callback) {

    const currentArray = array.filter(item => item.amount !== "");
    let arraySum = 0;
    if (currentArray.length > 0) {
        arraySum = currentArray.reduce((accumulator, current) => accumulator + parseFloat(current.amount, 10), 0);
    }
    if (repeater === "additions") currentAdditionsSum = arraySum;
    else currentDeductionsSum = arraySum;
    callback();

}